import { formatLocaleNumber } from "@/utils/formatUtils";
import { Descriptions, DescriptionsProps } from "antd";
import { useTranslation } from "react-i18next";
import { ProductCommissionsBusinessCoefficient } from "../types";

type Props = {
  businessCoefficients: ProductCommissionsBusinessCoefficient[];
};

export const BusinessCoefficientsDescriptions = ({ businessCoefficients }: Props) => {
  const { t } = useTranslation();

  const items: DescriptionsProps["items"] = businessCoefficients.flatMap((businessCoefficient) => [
    {
      key: `${businessCoefficient.id}-valueFrom`,
      label: t("commissions.productCommissionsSettings.attrs.businessCoefficients.valueFrom"),
      children: businessCoefficient.valueFrom,
    },
    {
      key: `${businessCoefficient.id}-valueTo`,
      label: t("commissions.productCommissionsSettings.attrs.businessCoefficients.valueTo"),
      children: businessCoefficient.valueTo,
    },
    {
      key: `${businessCoefficient.id}-coefficient`,
      label: t("commissions.productCommissionsSettings.attrs.businessCoefficients.coefficient"),
      children: formatLocaleNumber(businessCoefficient.coefficient, 6),
    },
  ]);

  return <Descriptions column={3} items={items} />;
};
